import { Component } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {AppConfigService} from "../../services/config/app-config.service";
import {TokenStorageService} from "../../services/storage/token-storage.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-generate-assertion',
    templateUrl: './generate-assertion.component.html',
    styleUrl: './generate-assertion.component.css',
    standalone: false
})
export class GenerateAssertionComponent {
  env: string | null;
  assertionGenAppUrl: SafeResourceUrl | null = null;

  constructor(appConfig: AppConfigService, private tokenStorageService: TokenStorageService, private sanitizer: DomSanitizer) {
    this.env = tokenStorageService.getUserEnv();
  }

  ngOnInit(): void {
    this.assertionGenAppUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.assertionGenAppUrl);
  }
}
